<template>
  <div class="b-contract-edit-errors">
    <div class="b-contract-edit-errors__icon-wrap p-4">
      <dynamic-icon icon="warning"></dynamic-icon>
    </div>
    <div class="b-contract-edit-errors__messages">
      <p class="mb-1">{{ checkContract || '' }}</p>
      <p class="mb-1">{{ checkAssets || '' }}</p>
      <p class="mb-1">{{ checkEmptyAssets || '' }}</p>
      <p class="mb-1">{{ checkNoAssetsLessors || '' }}</p>
      <p class="mb-1">{{ checkEmptyPaymentsForAsset || '' }}</p>
      <p class="mb-1">{{ checkPayments || '' }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    editContract: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters(['getAssets', 'getPaymentNames', 'allCounterparties']),
    checkContract() {
      if (!this.editContract.contract.number
        || !this.editContract.contract.date
        || !this.editContract.contract.lesseeCounterpartyId
        || this.editContract.contract.lessorCounterpartyIds.length === 0) {
        this.errors.contract = true;
        return 'Не заполнены обязательные поля для договора';
      }

      this.errors.contract = false;
      return false;
    },
    checkAssets() {
      const assetList = [];
      this.editContract.assetComponents.forEach((asset) => {
        if ((asset.quantity === null || undefined) || !asset.unitOfMeasureCode || !asset.startDate || !asset.endDate) {
          assetList.push(asset.name || this.getAssetName(asset.assetId));
        }
      });

      if (assetList.length > 0) {
        this.errors.assets = true;
        return `Не заполнены обязательные поля для следующих активов/компонентов: ${assetList.join(', ')}`;
      }

      this.errors.assets = false;
      return false;
    },
    checkEmptyAssets() {
      const emptyAssets = this.editContract.assetComponents
        .filter(assetComponent => assetComponent.lessorComponentShares.length === 0)

      if (emptyAssets.length > 0) {
        this.errors.emptyAssets = true
        return `Должен быть минимум один арендодатель у следющих активов: ${emptyAssets.map(a => a.name).join(', ')}`;
      }

      this.errors.emptyAssets = false
      return false;
    },
    checkNoAssetsLessors() {
      const contract = this.editContract.contract
      const lessors = this.allCounterparties.filter(cp => contract.lessorCounterpartyIds.includes(cp.idInDB))

      const assetLessorsIds = this.editContract.assetComponents
        .flatMap(asset => asset.lessorComponentShares)
        .flatMap(lessorComponentShare => lessorComponentShare.lessorId)

      const noAssetsLessors = lessors.filter(lessor => !assetLessorsIds.includes(lessor.idInDB))

      if (noAssetsLessors.length > 0) {
        this.errors.noAssetsLessors = true;
        return `Необходимо задать долю хотя бы в одном из активов для следующих арендодателей: ${noAssetsLessors.map(a => a.fullName).join(', ')}`;
      }

      this.errors.noAssetsLessors = false;
      return false;
    },
    checkEmptyPaymentsForAsset() {
      const assetList = [];

      this.editContract.assetComponents.forEach((asset) => {
        asset.lessorComponentShares.forEach((lessor) => {
          if (lessor.paymentsParameters.length === 0) {
            assetList.push(`${this.getLesseeName(lessor.lessorId)}(${asset.name || this.getAssetName(asset.assetId)})`);
          }
        });
      });

      if (assetList.length > 0) {
        this.errors.emptyPayments = true;
        return `Должен быть создан минимум один платеж для следующих арендодателей: ${assetList.join(', ')}`;
      }

      this.errors.emptyPayments = false;
      return false;
    },
    checkPayments() {
      const paymentList = [];

      this.editContract.assetComponents.forEach((asset) => {
        asset.lessorComponentShares.forEach((lessor) => {
          lessor.paymentsParameters.forEach((payment) => {
            if (!payment.paymentNameId
              || !payment.currencyCode
              || (payment.leaseRate === null || undefined)
              || !payment.startDate
              || !payment.firstPaymentDate
              || !payment.leaseFrequency
              || !payment.paymentFrequency
              || !payment.indexation
              || !payment.discount) {
              paymentList.push(`${this.getPaymentName(payment.paymentNameId)}(${asset.name} => ${this.getLesseeName(lessor.lessorId)})`);
            }
          });
        });
      });

      if (paymentList.length > 0) {
        this.errors.payments = true;
        return `Не заполнены обязательные поля для следующих платежей: ${paymentList.join(', ')}`;
      }

      this.errors.payments = false;
      return false;
    },
  },
  methods: {
    getAssetName(assetId) {
      for (let i = 0; i < this.getAssets.length; i++) {
        if (this.getAssets[i].idInDB === assetId) {
          return this.getAssets[i].name;
        }
      }
    },
    getPaymentName(paymentNameId) {
      for (let i = 0; i < this.getPaymentNames.length; i++) {
        if (this.getPaymentNames[i].idInDB === paymentNameId) {
          return this.getPaymentNames[i].name;
        }
      }
    },
    getLesseeName(lesseeId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if (this.allCounterparties[i].idInDB === lesseeId) {
          return this.allCounterparties[i].displayName;
        }
      }
    }
  },
};
</script>
